import PropTypes from 'prop-types';
import { Fragment } from 'react';

import { analytics, getLanguageSwitcher } from '@/utils/analytics';

import Text from '@/atoms/Text/Text';
import { CtaWrapper } from '@/molecules/CTA/index';

function LangSwitcher({ domains, locales, locale, path, style }) {
  const langSymbols = [
    { symbol: 'ko-KR', label: 'KR' },
    { symbol: 'en-AU', label: 'EN' },
  ];
  const handleChangeLanguage = (e, { url, name }) => {
    analytics({
      window,
      document,
      detail: getLanguageSwitcher(e, { url, name }),
    });
  };

  return (
    <div className={`aaco-lang-switcher nav-menu__actions__lang gap-x-[15px] justify-center items-center ${style}`}>
      {locales.sort().map((item, index) => {
        const domain = domains.find((d) => d.defaultLocale === item).domain;
        const url = `https://${domain}`;
        return (
          <Fragment key={index}>
            <CtaWrapper
              url={url}
            onClick={(e, { name }) => handleChangeLanguage(e, { name, url })}
            locale={item}
            classNames={`no-text-underline ${
              locale === item ? 'cursor-default' : ''
            }`}
          >
            <Text
              tag="body"
              style={`text-white ${locale !== item ? 'opacity-[0.3]' : ''}`}
            >
              {langSymbols.some((l) => l.symbol === item)
                ? langSymbols.find((l) => l.symbol === item).label
                : item}
            </Text>
          </CtaWrapper>
          {index < locales.length - 1 && (
            <div className="nav-menu__actions__lang__divider w-[1px] h-[18px] bg-white opacity-[0.3]"></div>
          )}
        </Fragment>
      )
    })}
    </div>
  );
}

LangSwitcher.propTypes = {
  domains: PropTypes.array,
  locales: PropTypes.array,
  locale: PropTypes.string,
  path: PropTypes.string,
  style: PropTypes.string,
};

LangSwitcher.defaultProps = {
  domains: [],
  locales: [],
  locale: '',
  path: '',
  style: '',
};

export default LangSwitcher;
